import React, { useState } from 'react';
import { useOnChange } from "components/hooks/useOnChange";
import useForm from "modules/forms/hooks/useForm";
import { Contact, FormFlowContext } from 'modules/forms/context/FormFlowContext';
import { Route, Routes } from "react-router-dom";
import CustomPage from "modules/forms/embedded/public/pages/CustomPage";
import CustomSuccess from "modules/forms/embedded/public/pages/CustomSuccess";
import { useSessionStorage } from "usehooks-ts";

export default function BootPublicForm() {
    const { form } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [contact, setContact] = useSessionStorage<Contact>('contact', null);
    const [values, setValues] = useState(form.default_values);
    const onChange = useOnChange(setValues);

    return (
        <FormFlowContext.Provider value={{
            values: values,
            isSubmitting: isSubmitting,
            setIsSubmitting: setIsSubmitting,
            contact: contact,
            setContact: setContact,
            onChange: onChange,
            setValues: setValues,
        }}
        >
            <Routes>
                <Route
                    path={"/custom"}
                    element={<CustomPage/>}
                />
                <Route
                    path={"/custom-success"}
                    element={<CustomSuccess/>}
                />
            </Routes>
        </FormFlowContext.Provider>
    );
}